import * as ko from "knockout";
import {nsFa} from "../../../fa/fn";
import {IRuleMutableAttribute} from "../../index";
import {global} from "../../../../appContext";
import {IRule, ISyncField} from "../../../../index";
import {getObjectDefinition, getSourceTranslation} from "../../../../util/misc";
import {ObjectTypeId, TEXT_WRAPPER_END, TEXT_WRAPPER_START} from "../../../../constants";

export namespace nsRule {

    export enum InputMode {
        DatePicker,
        Range,
        Select,
        Text,
    }

    import i = nsFa.i;

    export const DialogPickObjectAttributeTitle = `${i('fa-shapes')} ((choose subject|s:((attribute|ac))))`;

    export const doDialogPickObjectAttributeValue = (callback: (val: any) => void, ruleMutable: IRuleMutableAttribute) => {
        global.dialogManager.addComponent({
            title: ko.observable(DialogPickObjectAttributeTitle),
            content: {
                name: "component/ruleset/mutable/rule/dialog/pick-object-attribute",
                params: {
                    callback: callback,
                    ruleMutable: ruleMutable,
                }
            }
        });
    }

    export function getSyncFieldText(sf: ISyncField): string | null {
        if (!sf) {
            return null;
        }
        let ret = getSourceTranslation(sf);
        if (![ObjectTypeId.User, ObjectTypeId.Department, ObjectTypeId.Group, ObjectTypeId.FormData].includes(sf.objecttypeid)) {
            ret += '*';
        }
        return ret;
    }

    export function getSyncFieldTitle(sf: ISyncField): string | null {
        if (!sf) {
            return null;
        }
        let ret = sf.description || sf.name;
        const def = getObjectDefinition(sf.objecttypeid);
        if (def) {
            ret += ` (${def.translation})`;
        }
        return ret;
    }

    export function getSyncFieldStyle(sf: ISyncField): object | undefined {
        if (!sf) {
            return undefined;
        }
        if (sf.objecttypeid >= 4) {
            return {
                background: '#f8f8f8'
            }
        }
        return undefined;
    }

    export function parseArrayArgument(str: IRule['argument']): string[] {
        const s = String(str).replace(/^(,+)?(.*?)(,+)?$/gm, '$2')
        if (!s) {
            return []
        }
        if (!s.includes(',')) {
            // not multiple arguments
            return [s]
        }
        let lastIndex = 0
        const ret: string[] = []
        for (let i = 0; i < s.length; i++) {
            if (s.charAt(i) == ',') {
                if (!isIndexWithinExpression(s, i)) {
                    const substr = s.substring(lastIndex, i);
                    if (substr) {
                        ret.push(substr)
                    }
                    // skip the comma on next substring
                    lastIndex = i + 1
                }
            }
        }
        ret.push(s.substring(lastIndex))
        if (!ret.length) {
            ret.push(s)
        }
        return ret
    }


    export function isIndexWithinExpression(str: string, index: number): boolean {
        let counter: number = 0;
        for (let i = 0; i < index; i++) {
            const char = str.charAt(i)
            switch (char) {
                case TEXT_WRAPPER_START:
                    counter++
                    break
                case TEXT_WRAPPER_END:
                    counter--
                    break
            }
        }
        return counter != 0
    }


}